import { Button } from '@w7/ui'
import { claims, logout } from '@/auth/oidc'
import { LoginStage } from './LoginStage'
import { W7Mark } from './W7Mark'
import './auth.css'

export function NoAccessPage() {
  const who = claims()
  const label = who?.preferredUsername || who?.email || who?.sub || 'this account'

  return (
    <div className="w7-auth" data-testid="no-access">
      <LoginStage />
      <div className="w7-auth-panel">
        <div className="w7-auth-panel-bg" aria-hidden="true">
          <img className="w7-auth-panel-bg-a" src="/auth/editorial/form-ai-bg.png" alt="" decoding="async" />
          <img className="w7-auth-panel-bg-b" src="/auth/editorial/form-ai-bg.png" alt="" decoding="async" />
          <div className="w7-auth-panel-veil" />
        </div>
        <div className="w7-auth-card">
          <div className="w7-auth-brand">
            <W7Mark className="w7-auth-mark-word" size={48} />
            <span className="w7-auth-brand-name">Ops console</span>
          </div>

          <p className="w7-auth-eyebrow">Access</p>
          <h1 className="w7-auth-title">No access</h1>
          <p className="w7-auth-alert" role="status">
            {label} is not permitted to use this console. Contact support if this is unexpected.
          </p>

          <div className="w7-auth-actions">
            <Button variant="primary" onClick={() => logout()} data-testid="logout">
              Sign out
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
